<h1 mat-dialog-title>
  <div [style.font-size.px]="media.isActive('lt-sm') ? '16' : ''">
    {{ 'LABEL_FILTER' | translate }}
  </div>
</h1>

<div mat-dialog-content fxLayout="column" fxAlign="center center">
  <div fxLayout="column" fxLayoutGap="20px">

    <form [formGroup]="formGroup" novalidate autocomplete="off" autocorrect="off">

      <!-- Industry -->
      <ng-container>
        <esc-generic-dropdown
          class="width-100" 
          [loading]="loading"
          [getMore]="getMore"
          [isRequired]="true"
          [arrayName]="'industries'"
          [dropDownData]="industries"
          [dropdownType]="'industry'"
          [dropdownLabel]="'Industry'"
          [doesntExistLabel]="'Industry'"
          [requiredError]="industryRequired"
          [previousData]="formGroup.get('industry').value"
          (fetchData)="getData($event)"
          (optionSelected)="industrySelected($event)"
          (clearDropDownData)="industries = []"
          >
        </esc-generic-dropdown>
      </ng-container>

      <!-- Status -->
      <div>
        <mat-form-field class="form-field-filter">
          <mat-label>
            {{ 'LABEL_STATUS' | translate }}
          </mat-label>

          <mat-select formControlName="status" [compareWith]="compareWithFunc" required>
            <mat-option *ngFor="let opt of statuses" [value]="opt">
              {{opt.description}}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="formGroup.controls['status'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error> 
        </mat-form-field>
      </div>
    </form>

  </div>
</div>

<div mat-dialog-actions *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-button (click)="applyFilters()"> {{ 'LABEL_APPLY' | translate }} </button>
  <button type="button" color="warn" mat-button (click)="reset()"> {{ 'LABEL_RESET' | translate }} </button>
  <button type="button" mat-button (click)="dialogRef.close()"> {{ 'LABEL_CANCEL' | translate }} </button>
</div>

<!-- buttons for mobile view -->
<div mat-dialog-actions *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-icon-button (click)="applyFilters()">
    <mat-icon svgIcon="check"></mat-icon>
  </button>

  <button type="button" color="warn" mat-icon-button (click)="reset()">
    <mat-icon svgIcon="restore"></mat-icon>
  </button>

  <button type="button" mat-icon-button (click)="dialogRef.close()">
    <mat-icon svgIcon="cancel"></mat-icon>
  </button>
</div>